import React, { useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Collapsable,
} from '../../../components';

import WysiwygField from '../../../components/WysiwygField';

import './style.scss';

// showIcon is step plan version used for example in Ketenaanpak, not collapsable, always open, and with icons in the circles

const ParagraphStepPlan = ({ entity }) => {
  const showIcon = entity.getIn(['field_show_icon', 0, 'value']);
  const items = entity.get('field_subparagraphs');
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'value']);
  const variant = entity.getIn(['field_variant', 0, 'value']);
  const [OpenStepPlan, setOpenStepPlan] = useState(showIcon);
  const { t } = useTranslation();

  const toggleStepPlan = () => {
    if (!showIcon) {
      setOpenStepPlan(!OpenStepPlan);
    }
  };

  return (
    <Container className="Paragraph">
      <div className="row">
        <div className="col-12 col-lg-8 offset-lg-2">
          <div className={`ParagraphStepPlan ${variant && `color--${variant}`} ${showIcon ? 'showIcon' : ''}`}>
            <div className="ParagraphStepPlan__container">
              {title && !showIcon && <h2 className="ParagraphStepPlan__title">{title}</h2>}
              {title && showIcon && <h3 className="ParagraphStepPlan__title">{title}</h3>}

              {/* for option with the icon showed, we will use just a WysiwygField */}
              {showIcon && <WysiwygField property="schema:text" html={body} className="ParagraphStepPlan__body" />}

              {/* classic collapsable step plan needs logic to expand and collapse */}
              {!showIcon && (
                <div className="ParagraphStepPlan__items" onClick={toggleStepPlan}>
                  {!OpenStepPlan && t('implementations.Paragraph.StepPlan.expand')}
                  {OpenStepPlan && t('implementations.Paragraph.StepPlan.collapse')}

                  <div className={classnames('icon icon-variant-0 icon-chevron-right', { icon__close: !OpenStepPlan })} />
                </div>
              )}
            </div>

            <div className={classnames('ParagraphStepPlan__inner', { ParagraphStepPlan__close: OpenStepPlan })}>
              {items && items.size > 0 && (
                items.map((item, index) => {
                  const itemTitle = item.getIn(['entity', 'field_title', 0, 'value']);
                  const itemSupertitle = item.getIn(['entity', 'field_supertitle', 0, 'value']);
                  const itemBody = item.getIn(['entity', 'field_body', 0, 'processed']);
                  const itemUrl = item.getIn(['entity', 'field_link', 0, 'alias'], item.getIn(['entity', 'field_link', 0, 'uri'], null));
                  const itemSvg = item.getIn(['entity', 'field_media_image', 0, 'source']);
                  const uuid = item.getIn(['entity', 'uuid', 0, 'value']);
                  return (
                    <Collapsable
                      type={showIcon ? 'stepplan_icon' : 'stepplan'}
                      key={uuid}
                      title={itemTitle}
                      body={itemBody}
                      index={index}
                      roundedIcon
                      variant={variant}
                      OpenStepPlan={OpenStepPlan}
                      url={itemUrl}
                      svg={itemSvg}
                      supertitle={itemSupertitle}
                      middle={index > 0 && index < items.size - 1}
                    />
                  );
                })
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
export default ParagraphStepPlan;
